import { Team, Profile } from "@brg/api"
import { TeamStatusDrafts } from "shared/helpers/teamsStatus"
import { ModerationType } from "shared/pages/teams/const/ModerationTypes"

const isFormerChannelTab = (team: Team<'Global'>) => {
    const missingFilterProperty = team?.tabs?.some((tab) => !tab?.filter?.hasOwnProperty('usingFilterOrManual'))
    const hasProjectIds = team?.tabs?.some((tab) => tab?.filter?.hasOwnProperty('projectIds') && tab?.filter?.projectIds?.length > 0)
    return missingFilterProperty && hasProjectIds
}

const hasManualSettings = (team: Team<'Global'>) => {
    if (team && team?.tabs && team?.tabs?.length > 0) {
        return team?.tabs?.some((tab) => tab?.filter?.hasOwnProperty('usingFilterOrManual') && tab?.filter?.usingFilterOrManual === false)
    }
    return team?.mainFilter?.hasOwnProperty('usingFilterOrManual') && team?.mainFilter?.usingFilterOrManual === false
}

export const allowedRepostItems = (teams: Team<'Global'>[], profile?: Profile) => {
    if (!profile) return [];
    return teams.filter((team) => {
        const isOwner = team?.ownersIDs?.includes(profile?.accountId ?? '')
        const isEnableFeed = team?.enableFeed;
        const hasManualSettingTab = hasManualSettings(team)
        const isFormerChannel = isFormerChannelTab(team)

        if (TeamStatusDrafts(team)) return false;
        else if (team?.moderationType === ModerationType.Outer) {
            return isOwner && isEnableFeed && (hasManualSettingTab || isFormerChannel)
        }
        return isOwner
    })
}import { Team, Profile } from "@brg/api"
import { TeamStatusDrafts } from "shared/helpers/teamsStatus"
import { ModerationType } from "shared/pages/teams/const/ModerationTypes"

const isFormerChannelTab = (team: Team<'Global'>) => {
    const missingFilterProperty = team?.tabs?.some((tab) => !tab?.filter?.hasOwnProperty('usingFilterOrManual'))
    const hasProjectIds = team?.tabs?.some((tab) => tab?.filter?.hasOwnProperty('projectIds') && tab?.filter?.projectIds?.length > 0)
    return missingFilterProperty && hasProjectIds
}

const hasManualSettings = (team: Team<'Global'>) => {
    if (team && team?.tabs && team?.tabs?.length > 0) {
        return team?.tabs?.some((tab) => tab?.filter?.hasOwnProperty('usingFilterOrManual') && tab?.filter?.usingFilterOrManual === false)
    }
    return team?.mainFilter?.hasOwnProperty('usingFilterOrManual') && team?.mainFilter?.usingFilterOrManual === false
}

export const allowedRepostItems = (teams: Team<'Global'>[], profile?: Profile) => {
    if (!profile) return [];
    return teams.filter((team) => {
        const isOwner = team?.ownersIDs?.includes(profile?.accountId ?? '')
        const isEnableFeed = team?.enableFeed;
        const hasManualSettingTab = hasManualSettings(team)
        const isFormerChannel = isFormerChannelTab(team)

        if (TeamStatusDrafts(team)) return false;
        else if (team?.moderationType === ModerationType.Outer) {
            return isOwner && isEnableFeed && (hasManualSettingTab || isFormerChannel)
        }
        return isOwner
    })
}